import $ from 'jquery';
import * as lastComments from "../../blocks/last_comments/lastcomments";
import {globals} from "../../../core/utils/globals";

export function init() {
    lastComments.init({
        heightTarget: '#blogContent',
        commentsType: 'blog'
    });

    const toggleFilterClear = function() {
        const filtered = ($('#sortSelect').val() !== 'add_date') || $('#shopSearch').val()
            || ($('.category-filter-item:checked').length > 0);

        if(filtered) {
            $('.filter-clear-wrapper').show();
        } else {
            $('.filter-clear-wrapper').hide();
        }
    };

    $('#sortSelect').change(function(e) {
        $.cookie('blog_sort_by', $(this).val(), {expires: 365, path: '/'});

        toggleFilterClear();
        $(document).trigger('reloadSales');
    });
    $('#filterSelect').change(function(e) {
        $.cookie('blog_date_filter', $(this).val(), {expires: 365, path: '/'});

        toggleFilterClear();
        $(document).trigger('reloadSales');
    });

    $('#shopSearch').on('keyup paste', function(e) {
        toggleFilterClear();
        $(document).trigger('reloadSales');
    });

    $('.category-filter-item-wrapper').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        let $checkBox = $this.find('.category-filter-item');

        let category = $checkBox.data('slug');
        let checked = !$this.hasClass('current-cat');

        const blogType = globals('blogType');
        if (blogType != 'sale_new') {
            // just go to new location
            if (checked) {
	            const blogUrl = globals('blogUrl');
                location.href = blogUrl + '/category/' + category;
            }
            return;
        }

        let categories = $.cookie('blog_categories_filter');

        $checkBox.prop('checked', checked);
        $this.toggleClass('current-cat', checked);

        if(categories === undefined) {
            categories = [];
        } else {
            categories = categories.split(',');
        }

        let arrIndex = categories.indexOf(category);
        if(checked && arrIndex === -1) {
            categories.push(category);
        } else if(!checked && arrIndex !== -1) {
            categories.splice(arrIndex, 1);
        }

        $.cookie('blog_categories_filter', categories.join(','), {path: '/'});

        toggleFilterClear();
        $(document).trigger('reloadSales');
    });

    $('.filter-clear').click(function (e) {
        e.preventDefault();

        //Clear cookies
        $.removeCookie('blog_sort_by', {path: '/'});
        $.removeCookie('blog_categories_filter', {path: '/'});

        const blogType = globals('blogType');
        if (blogType === 'sale_new') {
            //Clear elements
            $('#sortSelect').val('add_date').trigger('chosen:updated');
            $('#shopSearch').val('');
            $('.category-filter-item').prop('checked', false);
            $('.category-filter-item-wrapper').toggleClass('current-cat', false);

            $('.filter-clear-wrapper').hide();
            $(document).trigger('reloadSales');
        } else {
            window.location = '/articles';
        }
    });
}


// WEBPACK FOOTER //
// ./modules/blog/sidebar/index.js